import { IPromoProduct } from '../../types/product';
import { IApplicationState } from '../../types/redux';

export const selectPromoProduct = (state: IApplicationState): IPromoProduct | null => {
  return state.promoDetails.analyticsProduct;
};
